import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productCategoriesApi } from "api/api/productCategoriesApi/productCategoriesApi";
import { UpdateProductCategoryBody } from "api/api/productCategoriesApi/types";
import { toast } from "react-toastify";

export const updateProductCategory = createAsyncThunk<
  number,
  UpdateProductCategoryBody
>("productCategories/updateProductCategory", async (body, { rejectWithValue }) => {
  try {
    const data = await productCategoriesApi.updateProductCategory(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const errData = error.response?.data as { title?: string };
      toast.error(errData ? errData?.title : "Что-то пошло не так... Попробуйте обновить страницу");
      return rejectWithValue(errData?.title || "Unknown error");
    } else {
      console.error("Error while updating products", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});